import {
  FETCH_JOBS_FAILURE,
  FETCH_JOBS_REQUEST,
  FETCH_JOBS_SUCCESS,
  REQUEST_REFRESH,
  DO_REFRESH,
  RESET_JOBS,
  SET_CURRENT_PAGE,
  SET_STATUS_FILTER,
  SET_TYPE_FILTER,
  SET_SELECTED_JOB,
} from './jobs-list.actions';
import {
  Job,
  JobStatus,
  JobType,
} from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';
import { Action } from '../redux.types';

export type JobsListState = {
  jobs: Job<any>[];
  filter: {
    status: JobStatus | null;
    jobType: JobType | null;
  };
  currentPage: number;
  nextPageToken: string | null;
  loading: boolean;
  error: string | null;
  lastFetchedFirstPage: number | null;
  refresh: boolean;
  selectedJob: Job<any> | null;
};

const initialState: JobsListState = {
  jobs: [],
  filter: {
    status: null,
    jobType: null,
  },
  currentPage: 1,
  nextPageToken: null,
  loading: false,
  error: null,
  lastFetchedFirstPage: null,
  refresh: false,
  selectedJob: null,
};

export const jobsList = (
  state: JobsListState = initialState,
  { type, payload }: Action,
) => {
  switch (type) {
    case FETCH_JOBS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_JOBS_SUCCESS:
      const response = payload.rawResponse;
      if (
        response.nextPageToken !== null &&
        response.nextPageToken === state.nextPageToken
      ) {
        return { ...state, loading: false };
      }
      return {
        ...state,
        loading: false,
        jobs: [...state.jobs, ...response.jobs],
        nextPageToken: response.nextPageToken,
        lastFetchedFirstPage:
          state.currentPage === 1 ? Date.now() : state.lastFetchedFirstPage,
      };
    case FETCH_JOBS_FAILURE:
      return { ...state, loading: false, error: payload };
    case SET_STATUS_FILTER:
      return {
        ...state,
        filter: { ...state.filter, status: payload },
        jobs: [],
        currentPage: 1,
        nextPageToken: null,
      };
    case SET_TYPE_FILTER:
      return {
        ...state,
        filter: { ...state.filter, jobType: payload },
        jobs: [],
        currentPage: 1,
        nextPageToken: null,
      };
    case SET_CURRENT_PAGE:
      return { ...state, currentPage: payload };
    case RESET_JOBS:
      return initialState;
    case DO_REFRESH:
      return {
        ...initialState,
        filter: state.filter,
      };
    case REQUEST_REFRESH:
      return { ...state, refresh: payload };
    case SET_SELECTED_JOB:
      return { ...state, selectedJob: payload };
    default:
      return state;
  }
};
